import { BrandIconName } from '@gik/ui';

interface ILoginProvider {
  icon: BrandIconName;
  className: string;
  label: string;
  value: string;
}

// TODO: make an end-point to get this info from the server so we have it centralized there instead of repeating it here
// MVC/_ExternalRegisterListPartial.cshtml:5
// var loginProviders = Context.GetOwinContext().Authentication.GetExternalAuthenticationTypes();

const LoginProviders: ILoginProvider[] = [
  {
    icon: 'FacebookWhite',
    className: 'facebook-login',
    label: 'Facebook',
    value: 'Facebook',
  },
  {
    icon: 'GoogleWhite',
    className: 'google-login',
    label: 'Google',
    value: 'Google',
  },
];

export default LoginProviders;
